import { VIEWS_MAP } from '../../../../router/constants';
import { BADGE_TYPES } from '../../../../components/TitleBadge/consts';
import { ReactComponent as UploadBillIcon } from '../../../../assets/icons/svg/colored-icons/ic-colored-upload-bill.svg';
import { ReactComponent as ManualBillIcon } from '../../../../assets/billpay/manual-bill.svg';

export const MAX_FILE_SIZE_MB = 15;

export const ADD_BILL_TYPES = {
  FILE: 'file',
  MANUAL: 'manual',
};

export const NAVIGATION_ACTION_MAP = {
  UPLOAD_FILE: `/${VIEWS_MAP.BILLS.BASE}/${VIEWS_MAP.BILLS.UPLOAD_BILL_FILE}`,
  CREATE_BILL: `/${VIEWS_MAP.BILLS.BASE}/${VIEWS_MAP.BILLS.CREATE_BILL.BASE}`,
};

export const ADD_BILL_METHODS = [
  {
    title: 'ADD_BILL.ADD_METHOD_FILE_TITLE',
    type: ADD_BILL_TYPES.FILE,
    content: 'ADD_BILL.ADD_METHOD_FILE_CONTENT',
    IconAsset: UploadBillIcon,
    badge: {
      scheme: BADGE_TYPES.POPULAR,
      title: 'ADD_BILL.BADGE_TITLE',
    },
  },
  {
    title: 'ADD_BILL.ADD_METHOD_MANUAL_TITLE',
    type: ADD_BILL_TYPES.MANUAL,
    content: 'ADD_BILL.ADD_METHOD_MANUAL_CONTENT',
    IconAsset: ManualBillIcon,
    badge: null,
  },
];
